export default __webpack_public_path__ + "static/media/tik-tok.ac8bb8ff.svg";